module.exports = __webpack_public_path__ + "static/media/CV_joint_Finwhale.27d146ad.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/CV_joint_Finwhale.png
// module id = 170
// module chunks = 0